export interface CursorOption {
  height?: number;
  width?: number;
  url?: string;
}

export const cursorOptions: CursorOption = {
  height: 42,
  width: 42,
  url: 'url("/assets/img/cursor/magnifying-glass.svg")'
};
